import api, { fetchData } from "./api";

export interface Role {
    id: number;
    authority: string;
}

export const getListaRole = async () => {
    try {
        const endpoint: string = "/Role/all";
        const response = await fetchData<Role>(endpoint, {});
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar lista de permissões:", error);
        throw error;
    }
};